"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

function debugLog() {
  var args = [];

  for (var _i = 0; _i < arguments.length; _i++) {
    args[_i] = arguments[_i];
  }

  if (process.env.DEBUG !== "sentence-splitter") {
    return;
  }

  console.log.apply(console, ["sentence-splitter: "].concat(args));
}

exports.debugLog = debugLog;